// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__23fNu","importantInfo":"styles_importantInfo__2H4rZ"};